import { useState, useEffect } from "react";

import { checkWhiteList, signIn } from "../utils/firebaseUtils";
import { useNavigate } from "react-router-dom";

import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";

function Copyright(props: any) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="https://www.ucfmsas.org/">
        UCF MSAS
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const theme = createTheme();

interface props {
  user: any;
  setUser: Function;
}

export default function Signup({ user, setUser }: props) {
  let navigate = useNavigate();
  const [checked, setChecked] = useState(false);
  const [email, setEmail] = useState("");
  const [pwd, setPwd] = useState("");
  const [error, setError] = useState("");
  const [pwdShow, setPwdShow] = useState(false);

  useEffect(() => {
    const id = localStorage.getItem("id");
    if (id !== null) {
      navigate("/", { replace: true });
    }
  }, []);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    let lowerCase = email.toLowerCase();
    const message = await checkWhiteList(lowerCase);
    if (message !== "Worked!") {
      setError(message);
      return;
    }
    const status = await signIn(lowerCase, pwd);
    if (status.message === "Fail") {
      setError("Email or Password incorrect");
      return;
    }
    // save to localStorage
    localStorage.clear();
    localStorage.id = status.payload.id;
    setUser(status.payload);
    navigate("/", { replace: true });
  };

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography component="h1" variant="h5">
            Sign in
          </Typography>
          <Box
            component="form"
            onSubmit={handleSubmit}
            noValidate
            sx={{ mt: 1, width: "100%" }}
          >
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
              }}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              id="password"
              type={pwdShow ? "text" : "password"}
              label="Password"
              name="password"
              autoComplete="password"
              value={pwd}
              onChange={(e) => {
                setPwd(e.target.value);
              }}
            />
            {error.length > 10 && (
              <Typography sx={{ color: "red" }}>{error}</Typography>
            )}
            <FormControlLabel
              checked={pwdShow}
              control={
                <Checkbox name="remember" value="remember" color="primary" />
              }
              label="Show Password"
              onChange={() => setPwdShow(!pwdShow)}
            />
            <FormControlLabel
              checked={checked}
              control={
                <Checkbox name="remember" value="remember" color="primary" />
              }
              label="Remember me"
              onChange={() => setChecked(!checked)}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              disabled={email.length < 3}
              sx={{ mt: 3, mb: 2 }}
            >
              Sign In
            </Button>
            <Grid container>
              <Grid item xs></Grid>
              <Grid item>
                <Link href="#" variant="body2">
                  {"Don't have an account? Steps to troubleshoot"}
                </Link>
              </Grid>
            </Grid>
          </Box>
        </Box>
        <Copyright sx={{ mt: 8, mb: 4 }} />
      </Container>
    </ThemeProvider>
  );
}
